module.exports = __webpack_public_path__ + "img/img16.25f94798.svg";